import {
  Box,
  HStack,
  Step,
  StepIcon,
  StepIndicator,
  StepNumber,
  StepSeparator,
  StepStatus,
  Stepper,
  Text,
  VStack,
} from "@chakra-ui/react";

/**
 * Compact stepper: shows only circle indicators + connectors in the
 * track, then surfaces the active step's name + "Step N of M" text
 * below. Avoids the horizontal-overflow / label-overlap problems we
 * get when every step exposes its own StepTitle inline.
 */
export default function WizardStepper({ steps, activeStep }) {
  const current = steps[activeStep] || steps[steps.length - 1];

  return (
    <VStack spacing={2} align="stretch">
      <Stepper
        index={activeStep}
        colorScheme="blue"
        size="sm"
        gap={0}
      >
        {steps.map((_, i) => (
          <Step key={i}>
            <StepIndicator>
              <StepStatus
                complete={<StepIcon />}
                incomplete={<StepNumber />}
                active={<StepNumber />}
              />
            </StepIndicator>
            <StepSeparator />
          </Step>
        ))}
      </Stepper>
      <HStack justify="center" spacing={2}>
        <Text fontSize="xs" color="gray.500">
          Step {Math.min(activeStep + 1, steps.length)} of {steps.length}
        </Text>
        <Box w="1px" h="3" bg="gray.300" />
        <Text fontSize="xs" fontWeight="semibold" color="blue.600">
          {current?.title}
        </Text>
      </HStack>
    </VStack>
  );
}
